const ACTIVE_ENTITLEMENT_STATUSES = new Set(["active", "trialing", "grace_period"]);

export const marketplaceAppIsInstalled = (app) => {
  if (app?.installation?.status === "active") return true;

  return app?.slug === "website_pro"
    && ACTIVE_ENTITLEMENT_STATUSES.has(app?.billing?.status);
};

